import { withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/hotspot/back.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-40c05782")

_pushScopeId("data-v-40c05782")
const _hoisted_1 = { class: "go-back" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "buy-icon" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "点击购买", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("img", {
        src: _imports_0,
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.click && _ctx.click(...args)), ["stop","prevent"]))
      })
    ]),
    (_ctx.showBuy)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "buy-wrapper",
          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.buy && _ctx.buy(...args)), ["stop","prevent"]))
        }, [
          _hoisted_2,
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    (_ctx.showAction)
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          class: "create-wrapper",
          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args)), ["stop","prevent"])),
          style: _ctx.actionStyle
        }, [
          _createVNode("span", null, _toDisplayString(_ctx.actionText), 1)
        ], 4))
      : _createCommentVNode("", true)
  ]))
})